<template>
  <div class="pt-3">
    <b-container v-if="typeof $route.params.cod_hotel !== 'undefined'" class="pt-4">
      <b-row>
        <b-col sm="12" md="6" class="mb-2">
          <b-form-input type="text" :placeholder="trans['PESQUISA']" v-model="filter" v-if="$distribution.no_show.length > 0"></b-form-input>
        </b-col>
        <b-col cols="12" style="overflow-x: auto;">
          <table class="table text-center table-striped" v-if="$distribution.no_show.length > 0">            
            <thead class="bg-grey-dark text-white">
              <tr>
                <th scope="col">{{trans['RESERVA']}}</th>
                <th scope="col">{{trans['N_QUARTO']}}</th>
                <th scope="col">{{trans['TIPOLOGIA']}}</th>
                <th scope="col">Check-In</th>
                <th scope="col">Check-Out</th>
                <th scope="col">{{trans['ESTADO']}}</th>
                <th scope="col">{{trans['REGIME']}}</th>
                <th scope="col">{{trans['ADULTOS']}}</th>
                <th scope="col">{{trans['CRIANCAS_4_12']}}</th>
                <th scope="col">{{trans['CRIANCAS_0_3']}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(no_show_rsv, key) in no_show_data" :key="key">
                <td scope="row" v-html="highlight_matches(no_show_rsv.reserva)"></td>
                <td scope="row" v-html="highlight_matches(no_show_rsv.n_quarto)"></td>
                <td scope="row" v-html="highlight_matches(no_show_rsv.tipologia)"></td>
                <td scope="row">{{ no_show_rsv.check_in }}</td>
                <td scope="row">{{ no_show_rsv.check_out }}</td>
                <td scope="row" v-html="highlight_matches(no_show_rsv.estado)"></td>
                <td scope="row">{{ no_show_rsv.regime }}</td>
                <td scope="row">{{ no_show_rsv.adultos }}</td>
                <td scope="row">{{ no_show_rsv.criancas_4_12 }}</td>
                <td scope="row">{{ no_show_rsv.criancas_0_3 }}</td>
              </tr>
            </tbody>
          </table>
          <b-alert v-else show variant="danger" class="text-center">{{trans['NAO_NO_SHOW']}}</b-alert>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>

export default {
  name: 'zone_no_show',
  data() {
    return {
      filter: ''
    }
  },
  methods: {
    highlight_matches(text) {
      const matchExists = text.toLowerCase().includes(this.filter.toLowerCase());
      if (!matchExists) return text;

      const re = new RegExp(this.filter, 'ig');
      return text.replace(re, matchedText => `<strong class="color-green">${matchedText}</strong>`);
    }
  },
  computed: {
    no_show_data: function() {
      return this.$distribution.no_show.filter(row => {
        const reserva    = row.reserva.toString().toLowerCase();
        const n_quarto   = row.n_quarto.toString().toLowerCase();
        const tipologia  = row.tipologia.toString().toLowerCase();
        const estado     = row.estado.toString().toLowerCase();
        const searchTerm = this.filter.toLowerCase();

        return reserva.includes(searchTerm) ||
          n_quarto.includes(searchTerm) || 
          tipologia.includes(searchTerm) || 
          estado.includes(searchTerm);
      });



    },
    dist_zone_data: function() {
      return this.get_zone();
    },
    send_data: function(items) {}, // just to exist and no error when main container call this
  },
  created: function() {   
    this.$emit('set_back_link', {name: 'list_zones', params: {lang: this.$route.params.lang,
                                                              search_hotel: this.$distribution.search_hotel,
                                                              search_bloco: this.$distribution.search_bloco,
                                                              search_piso: this.$distribution.search_piso,
                                                              search_n_quarto: this.$distribution.search_n_quarto}});
    this.$route.meta.title = this.trans['REPORT']+' - '+this.trans['NO_SHOW'];
  }
}
</script>
